var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32c5 0 9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2l0 42.7 64 0 0-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2l0 42.7 64 0 0-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2L512 448c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-64 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-64 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 117.3c0-6.9 2.2-13.7 6.4-19.2L51.2 38.4c3-4 7.8-6.4 12.8-6.4zM288 384l0-32 0-160 0-32 0-42.7L256 74.7l-32 42.7L224 448l64 0 0-64zm32-32l64 0 0-160-64 0 0 160zm96 0l0 32 0 64 64 0 0-330.7L448 74.7l-32 42.7L416 352zM192 192l-64 0 0 160 64 0 0-160zm-96 0l0-32 0-42.7L64 74.7 32 117.3 32 448l64 0 0-64 0-32 0-160z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFence);
export default __webpack_public_path__ + "static/media/fence.a76c8b713685d124920a22a68ecfea93.svg";
export { ForwardRef as ReactComponent };